import { render } from "./RelOrderModel.vue?vue&type=template&id=337f86ff&ts=true"
import script from "./RelOrderModel.vue?vue&type=script&lang=ts"
export * from "./RelOrderModel.vue?vue&type=script&lang=ts"

import "./RelOrderModel.vue?vue&type=style&index=0&id=337f86ff&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__